import * as types from "./types";


export const lock = {
  namespaced: true,

  state: {
    lock: false
  },
  getters: {
    loaded: (state)=> state.loaded
  },
  mutations: {
    setLock(state, lock) {
      state.lock = lock;
    }
  },
  actions: {
    [types.SET_LOCK]({ commit }, lock) {
      commit("setLock", lock);
    }
  }
};
